import React from 'react';

import { IconProps } from '../DefaultIcon';

export function IndicatorsIcon({ className }: IconProps) {
  return (
    <svg
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_2_377)">
        <path
          d="M54.6448 63.388H25.5737V74.9727H54.6448V63.388Z"
          fill="#EAEEF9"
        />
        <path
          d="M75.6284 65.5738H4.37158C1.96721 65.5738 0 63.6066 0 61.2022V12.459C0 10.0546 1.96721 8.08743 4.37158 8.08743H75.847C78.2514 8.08743 80.2186 10.0546 80.2186 12.459V61.2022C80 63.6066 78.2514 65.5738 75.6284 65.5738Z"
          fill="#EAEEF9"
        />
        <path
          d="M72.5684 56.3934H7.65039C6.33892 56.3934 5.4646 55.5191 5.4646 54.2076V15.7377C5.4646 14.4262 6.33892 13.5519 7.65039 13.5519H72.5684C73.8799 13.5519 74.7542 14.4262 74.7542 15.7377V54.4262C74.5356 55.5191 73.6613 56.3934 72.5684 56.3934Z"
          fill="white"
        />
        <path
          d="M66.6667 80H13.5519C12.2404 80 10.929 78.9071 10.929 77.3771C10.929 76.0656 12.0219 74.7541 13.5519 74.7541H66.6667C67.9781 74.7541 69.2896 75.847 69.2896 77.3771C69.2896 78.9071 67.9781 80 66.6667 80Z"
          fill="#EAEEF9"
        />
        <path
          d="M67.541 0L55.9563 3.06011C55.5192 3.06011 55.5192 3.71585 55.7378 3.93443L57.705 5.90164C57.9235 6.12022 57.9235 6.3388 57.705 6.55738L46.776 17.4863C46.5574 17.7049 46.3388 17.7049 46.1203 17.4863L41.3115 12.6776C41.0929 12.459 40.8744 12.459 40.6558 12.6776L30.3826 22.9508C30.164 23.1694 29.9454 23.1694 29.7268 22.9508L24.9181 18.1421C24.6995 17.9235 24.4809 17.9235 24.2623 18.1421L5.68311 36.5027V44.153L24.2623 25.7924C24.4809 25.5738 24.6995 25.5738 24.9181 25.7924L29.7268 30.6011C29.9454 30.8197 30.164 30.8197 30.3826 30.6011L40.6558 20.3279C40.8744 20.1093 41.0929 20.1093 41.3115 20.3279L46.1203 25.1366C46.3388 25.3552 46.5574 25.3552 46.776 25.1366L61.6394 10.4918C61.858 10.2732 62.0765 10.2732 62.2951 10.4918L64.2623 12.459C64.4809 12.6776 64.9181 12.6776 65.1367 12.2404L68.1968 0.874317C68.1968 0.218579 67.9782 0 67.541 0Z"
          fill="#00C4B3"
        />
        <path
          d="M15.7376 44.153H11.5846C10.9289 44.153 10.4917 44.5902 10.4917 45.2459V52.8962C10.4917 53.7705 11.1474 54.4262 12.0218 54.4262H15.7376C16.6119 54.4262 17.2677 53.7705 17.2677 52.8962V45.6831C17.0491 44.8088 16.3933 44.153 15.7376 44.153Z"
          fill="#00416B"
        />
        <path
          d="M24.4808 38.2514H20.3278C19.672 38.2514 19.2349 38.6885 19.2349 39.3443V52.8962C19.2349 53.7705 19.8906 54.4262 20.7649 54.4262H24.4808C25.3551 54.4262 26.0108 53.7705 26.0108 52.8962V39.7814C25.7922 38.9071 25.1365 38.2514 24.4808 38.2514Z"
          fill="#00416B"
        />
        <path
          d="M33.2241 41.0929H29.2897C28.6339 41.0929 28.1968 41.5301 28.1968 42.1858V52.6776C28.1968 53.5519 28.8525 54.2077 29.7268 54.2077H33.4427C34.317 54.2077 34.9727 53.5519 34.9727 52.6776V42.4044C34.5356 41.7486 33.8798 41.0929 33.2241 41.0929Z"
          fill="#00416B"
        />
        <path
          d="M41.9673 36.0656H38.0328C37.3771 36.0656 36.9399 36.5027 36.9399 37.1585V52.8962C36.9399 53.7705 37.5957 54.4262 38.47 54.4262H42.1858C43.0602 54.4262 43.7159 53.7705 43.7159 52.8962V37.5956C43.2787 36.7213 42.623 36.0656 41.9673 36.0656Z"
          fill="#00416B"
        />
        <path
          d="M50.7104 27.9781H46.776C46.1203 27.9781 45.6831 28.4153 45.6831 29.071V52.6776C45.6831 53.5519 46.3388 54.2077 47.2132 54.2077H50.929C51.8033 54.2077 52.4591 53.5519 52.4591 52.6776V29.5082C52.0219 28.6339 51.3662 27.9781 50.7104 27.9781Z"
          fill="#00416B"
        />
        <path
          d="M59.4536 31.694H55.5192C54.8634 31.694 54.4263 32.1311 54.4263 32.7869V52.8962C54.4263 53.7705 55.082 54.4262 55.9563 54.4262H59.6722C60.5465 54.4262 61.2022 53.7705 61.2022 52.8962V33.224C60.7651 32.3497 60.1093 31.694 59.4536 31.694Z"
          fill="#00416B"
        />
        <path
          d="M68.1968 19.235H64.2623C63.6066 19.235 63.1694 19.6721 63.1694 20.3279V52.6776C63.1694 53.5519 63.8252 54.2076 64.6995 54.2076H68.4153C69.2897 54.2076 69.9454 53.5519 69.9454 52.6776V20.765C69.5082 19.8907 68.8525 19.235 68.1968 19.235Z"
          fill="#00416B"
        />
      </g>
      <defs>
        <clipPath id="clip0_2_377">
          <rect width="80" height="80" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
